<template>
<v-container fluid style="padding-top:1px !important" pa-0 ma-0>
  <v-tabs
      fixed-tabs
      dark
      height="35"
      dense
      v-model="selectedNewSalesTab"
      class="promotion-tabs"
      background-color="#136DF5"
      style="position:fixed;top:35px;z-index:20" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#existingCustomers">Olemassa olevat asiakkaat </v-tab>
      <!-- <v-tab href="#promotionPDFGeneratorOld">Nopea PDF tarjous</v-tab> -->
      <v-tab href="#priorityLeads">Priority Liidit</v-tab>
      <v-tab href="#leads">Liidit</v-tab>
      <v-tab href="#readyForSend" v-if="allAccess">Valmis Lähetykseen</v-tab>
      <v-tab href="#dataProcessing" v-if="allAccess">Datan Prosessointi</v-tab>
      <v-tab href="#salesRegions" v-if="allAccess">Myyjien Alueet</v-tab>
    </v-tabs>
    <div v-if="selectedNewSalesTab === 'existingCustomers'" style="padding-top:35px;">
      
      <v-data-table
        :headers="headers"
        :items="getCampaignContacts"
        
        :items-per-page="30"
        item-key="id"
        fixed-header
        hide-default-header
        height="86.1vh"
        style="border-bottom:1px solid #ccc"
        :footer-props="{
          'items-per-page-options': [30, 50, 100]
        }"
        dense
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th :key="h.value+'-'+index" v-for="(h, index) in headers" :style="h.value === 'packageType' || h.value === 'select' ? 'font-size:10px;font-weight:600;vertical-align:top;color:#000;' : 'font-size:10px;font-weight:400;color:#666;padding-left:6px;'" class="">
                <div v-if="h.value === 'latestInteraction' || h.value === 'opens' || h.value === 'clicks'  || h.value === 'score'"><span style="color:#136df5;font-weight:600;text-decoration: underline;cursor: pointer;" @click="sortColumn = h.value">{{h.text}}</span></div>
                <div v-else><span>{{h.text}}</span></div>
                <div v-if="h.value === 'subject'" style="max-height:35px;max-width:90%;z-index:1000">
                  <v-autocomplete
                    autocomplete="off"
                    v-model="campaignIdFilter"
                    :items="getCampaignArrayForFilter"
                    hide-details
                    dense
                    spellcheck="false"
                    item-text="text"
                    item-value="id"
                    class="avecor-select avecor-header-input mt-0 pt-0"
                    style="z-index:1000;background:#ddd"
                  >
                    <template v-slot:selection="data">
                      
                        {{ data.item.text.substr(0,30) +'...' }}
                      
                    </template>
                  </v-autocomplete> 
                </div>
              </th>
            </tr>
          </thead>

        </template>
        <template v-slot:item="props">
          <tr style="height:25px;" class="hide-field-details" :style="'background:'+ statusColors[props.item.status]">
            <td class="text-center" style="width:40px;">
            <!--   <v-icon 
                :size="settings.tableSelectIconsSize"
                @click="deleteItem(props.item)"
              >
                far fa-trash-alt
              </v-icon>
            -->
              <v-icon 
                  :size="settings.tableSelectIconsSize"
                  @click="props.isExpanded ? props.expand(false) : props.expand(true)"
                  style="padding-left:3px;padding-top:5px;"
                >
                  {{props.isExpanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}}
              </v-icon>
              
            </td>
            
            <td style="min-width:100px;">
              <span v-if="props.item.latestInteraction">
                <span >{{eventNames[props.item.latestInteraction]}}</span>
                <span> - </span>
                <span >{{props.item.latestInteractionDate ? customFormatter(props.item.latestInteractionDate) : ''}}</span>
              </span>
              <!-- <v-text-field
                :value="getLatestInteraction(props.item)"
                class="avecor-select"
                readonly
                dense
                hide-details
              ></v-text-field> -->
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.contactType === 'contact' ? 'Kontakti' : 'Liidi'"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.deliveryCity"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.companyName"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.contactName"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.contactEmail"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <v-text-field
                :value="props.item.contactPhone"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            
            <td style="min-width:50px;max-width:50px;">
              <v-text-field
                slot="activator"
                class="avecor-date-picker mt-0"  
                :value="props.item.sendDate ? customFormatter(props.item.sendDate) : ''"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:250px;max-width:500px;">
              <v-text-field
                :value="props.item.subject"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            
            <td style="min-width:50px;max-width:50px;">
              <v-text-field
                :value="props.item.scores.score"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:50px;max-width:50px;">
              <v-text-field
                :value="props.item.scores.extras"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:50px;max-width:50px;">
              <v-text-field
                :value="props.item.opens"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:50px;max-width:50px;">
              <v-text-field
                :value="props.item.clicks"
                class="avecor-select mt-0"
                readonly
                dense
                hide-details
              ></v-text-field>
            </td>
            <td style="min-width:100px;">
              <select :value="props.item.status" class="status-select" style="" @click.stop @change="status => changeStatus(props.item.campaignId,props.item.contactId,status)">
                <option value="not_contacted">Ei kontaktoitu</option>
                <option value="called_no_answer">Soitettu - ei vastausta</option>
                <option value="called_not_interested">Soitettu - ei kinnostunut</option>
                <option value="meeting_booked">Tapaaminen saatu</option>
                <option value="offer_sent">Tarjous lähetetty</option>
                <option value="order_completed">Tilaus tehty</option>
              </select>  
            </td>
          </tr>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="ml-15" :colspan="headers.length" style="border-bottom:1px solid #ccc;background:#fafafa;">
            <div class="ml-12 my-0" v-for="(i,index) in getInteractions(item.campaignId,item.contactId)" :key="item.campaignId + item.contactId+index">
              <span>
                <v-text-field
                  style="display:inline-block;width:50px;"
                  slot="activator"
                  class="avecor-date-picker mt-0"  
                  :value="eventNames[i.event] ? eventNames[i.event] : ''"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </span>
              <span>
                <v-text-field
                  style="display:inline-block;"
                  slot="activator"
                  class="avecor-date-picker mt-0"  
                  :value="i.interactionDate ? customFormatter(i.interactionDate) : ''"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </span>
              <span>
                <v-text-field
                  style="display:inline-block;"
                  slot="activator"
                  class="avecor-date-picker mt-0"  
                  :value="i.url ? i.url : ''"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </span>
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-if="selectedNewSalesTab === 'salesRegions'">
      <v-toolbar class="" dense flat color="white" style="border-bottom:1px solid #ccc;position:fixed;top:84px;width:100%;background:#FFF !important;z-index:20">
        <v-toolbar-title>Alueet</v-toolbar-title>
        <v-col sm="1" pl-4 class="text-center">
          <!-- <div style="font-size:14px">{{amountOfCompanies}}</div>
          <div style="font-size:10px">Yritystä</div> -->
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="8" md="4">
          <v-text-field
            :value="regionsSearch"
            class="table-search avecor-no-underline"
            label="Hae yrityksiä (nimi, y-tunnus, osoite, kaupunki, netvisor id, myyjä)"
            autocomplete="off"
            @change="(event) => regionsSearch = event"
            hide-details
          ></v-text-field>
        </v-col>
        <v-spacer v-if="device === 'desktop'"></v-spacer>
        <div class="text-right" v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1'">
          <input type="file" id="fileInput" style="font-size:10px;width:150px;">
          <v-btn @click.stop="importRegions" color="#000000" dark class="avecor-button-global  add-button mr-3">Import</v-btn>
        </div>
        
      </v-toolbar>
      
      <v-row no-gutters style="margin-top:80px;position:fixed;z-index:20;width:100%;background:#FFF;border-bottom:1px solid #ccc;border-top:1px solid #ccc;" class="py-2">
        <v-col cols="1" class="orders-custom-header pl-3 pr-1">Maakunta</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Maakuta Ruotsiksi</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Maakunta Koodi</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Kunta</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Kunta Ruotsiksi</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Kunta Koodi</v-col>
        <v-col cols="2" class="orders-custom-header pr-1">Postikoodin Alue</v-col>
        <v-col cols="1" class="orders-custom-header pr-1">Postikoodi</v-col>
        <v-col cols="2" class="orders-custom-header pr-1">Myyjä
          <select :value="batchSalesperson" class="status-select ml-2" :style="'width:150px;'" @click.stop @change="v => updateSalespersonForBatch(v)">
            <option v-for="sp in getSalespersons" :key="sp.id+'__h'" :value="sp.id">{{sp.text}}</option>
          </select>  
        </v-col>
      </v-row>
      <div style="padding-top:125px;">
        <v-lazy
          style="width:100%; padding:0px; margin:0px;min-height:15px;"
          :options="{threshold: .9}"
          v-for="pc in getSalesRegions" :key="pc.postalCode"
        >
          <v-row no-gutters  >
            <v-col cols="1" class="companies-custom-field pl-3 pr-1">{{pc.stateName_fi}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.stateName_se}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.stateCode}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.districtName_fi}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.districtName_se}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.districtCode}}</v-col>
            <v-col cols="2" class="companies-custom-field pr-1">{{pc.postalCodeName}}</v-col>
            <v-col cols="1" class="companies-custom-field pr-1">{{pc.postalCode}}</v-col>
            
            <v-col cols="2" class="companies-custom-field pr-1">
              <input type="checkbox" :checked="batchUpdatePostalCodes[pc.postalCode]" @change="v => updateBatchStatusForItem(pc.postalCode, v)">
              <!-- <v-checkbox 
                style="margin-top:0px;"
                
                v-model="batchUpdatePostalCodes[pc.postalCode]" 
                @change="v => updateBatchStatusForItem(pc.postalCode, v)"
                class="avecor-table-checkbox">
              </v-checkbox> -->
              <select :value="pc.salesperson" class="status-select ml-2" :style="pc.salesperson !== '' ? 'width:150px;' : 'width:150px;;background:#FFF3E0'" @click.stop @change="v => updateSalespersonForPostalCode(pc.postalCode,v)">
                <option v-for="sp in getSalespersons" :key="sp.id+'_'+pc.postalCode+'_'" :value="sp.id">{{sp.text}}</option>
              </select>  
              
            </v-col>
          </v-row>
        </v-lazy>
      </div>
    </div>
    <div v-if="selectedNewSalesTab === 'priorityLeads' || selectedNewSalesTab === 'leads' || selectedNewSalesTab === 'readyForSend' || selectedNewSalesTab === 'dataProcessing'">
      <v-toolbar class="" dense flat color="white" style="border-bottom:1px solid #ccc;position:fixed;top:84px;width:100%;background:#FFF !important;z-index:20">
        <v-toolbar-title>
          {{selectedNewSalesTab === 'priorityLeads' ? 'Priority Liidit' : ''}}
          {{selectedNewSalesTab === 'leads' ? 'Liidit' : ''}}
          {{selectedNewSalesTab === 'readyForSend' ? 'Sähkoposti lähdössä' : ''}}
          {{selectedNewSalesTab === 'dataProcessing' ? 'Datan Keruu' : ''}}
          <span>
            <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" style="z-index:9999">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" >
                  <v-icon :size="16" style="padding-left:10px;padding-top:0px;">fas fa-list-alt</v-icon>
                </span>
              </template>
              <div style="font-size:11px;background:#FFF;padding:10px;">
                <div style="font-weight:600;font-size:13px;">Myyjittäin split</div>
                <br>
                <div v-if="getLeadSplit.length > 0">
                  <div v-for="l in getLeadSplit" :key="l.salesperson+'_split_amount'">
                    <div style="display:inline-block;width:150px;">{{l.salespersonName}}</div>
                    <div style="display:inline-block;width:150px;">{{l.amount}}</div>
                  </div>
                </div>
                <div v-else class="text-center my-5">
                  <span style="font-weight:600">Ei varauksessa olevia tuotetilauksia.</span>
                </div>
              </div>
            </v-menu>
          </span>
        </v-toolbar-title>
        <v-col sm="1" pl-4 class="text-center">
          <!-- <div style="font-size:14px">{{amountOfCompanies}}</div>
          <div style="font-size:10px">Yritystä</div> -->
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" md="2">
          <v-text-field
            :value="leadsSearch"
            class="table-search avecor-no-underline"
            label="Hae yrityksen nimellä, y-tunnuksella, toimialallla"
            autocomplete="off"
            @change="(event) => leadsSearch = event"
            hide-details
          ></v-text-field>
        </v-col>
        <v-spacer v-if="device === 'desktop'"></v-spacer>
        <span v-if="user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' && selectedNewSalesTab === 'dataProcessing'">
          <!-- <span style="font-size:12px;">Prosessoi prio liideinä?</span>
          <span class="pl-4 pr-10"><input type="checkbox" :checked="loadAsPriorityLeads" @change="v => loadAsPriorityLeads = v.target.checked" ></span> -->
          <span class="text-right" >
            <input type="file" accept=".csv" id="fileInputProspects" style="font-size:10px;width:150px;">
            <v-btn @click.stop="importProspects" color="#000000" dark class="avecor-button-global  add-button mr-3">Import</v-btn>
          </span>
        </span>
        <div v-if="selectedNewSalesTab === 'leads' && device === 'desktop' && allAccess" style="display:inline-block;">
          <select v-model="exportSalespersonFilter" class="status-select mt-0 mr-2" style="height:23px;">
            <option v-for="(sp) in getSalespersonsFilter" :key="'salesperson_filter'+sp.id" :value="sp.id">
              {{sp.text}}
            </option>
          </select>
          
          <!-- <v-autocomplete
            style="max-width:200px;z-index:1000;display:inline-block;"
            label="Myyjä suodatin exporttiin"
            :value="exportSalespersonFilter"
            @change="v => exportSalespersonFilter = v"
            :items="getSalespersonsFilter"
            outlined
            dense
            persistent-hint
            item-text="text"
            item-value="id"
            class="avecor-select hide-field-details mr-5 mt-3"
          /> -->
          <v-menu
            :offset-y="true"
            :nudge-bottom="0"
            :nudge-right="0"
            bottom
            :close-on-click="true"
            v-if="device === 'desktop' && allAccess"
            
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                v-bind="attrs"
                v-on="on"
                class="avecor-button-global add-button mr-5 "
              >
                Export
              </v-btn>
            </template>

            <v-list>
              <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts')" style="cursor:pointer;">Avecorin Asiakkaat</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportContactsAndLeads('non_prio_leads')" style="cursor:pointer;">Ei-prio liidit</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts_and_non_prio_leads')" style="cursor:pointer;">Avecorin Asiakkaat ja normi liidit</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts_and_all_leads')" style="cursor:pointer;">Avecorin Asiakkaat + normi liidit + prio liidit</v-list-item-title></v-list-item>
              <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts_and_non_prio_leads_already_contacted')" style="cursor:pointer;">Avecorin Asiakkaat + normi liidit joille jo lähetetty sähköpostia</v-list-item-title></v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-btn v-if="device === 'desktop' && selectedNewSalesTab === 'leads'" @click.stop="newLeadModalVisible = true" color="#000000" dark class="avecor-button-global add-button mb-2 mt-2" >Lisää Liidi</v-btn>
      </v-toolbar>
      
      <v-row no-gutters style="margin-top:80px;position:fixed;z-index:20;width:100%;background:#FFF;border-bottom:1px solid #ccc;border-top:1px solid #ccc;" class="py-2">
        <v-col cols="5">
          <v-row no-gutters>
            <v-col cols="1" style="max-width:75px;" class="orders-custom-header pl-3 pr-1"></v-col>
            <v-col cols="1" class="orders-custom-header pl-3 pr-1">Myyjä</v-col>
            <v-col cols="2" class="orders-custom-header pr-1">Yritys</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Y-tunnus</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Yhtiömuoto</v-col>
            <v-col cols="2" class="orders-custom-header pr-1">Osoite</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Postikoodi</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Kaupunki</v-col>
            <v-col cols="2" class="orders-custom-header pr-1">Verkkosivu</v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-row no-gutters>
            <v-col cols="2" class="orders-custom-header pr-1">Henkilös.</v-col>
            <v-col cols="4" class="orders-custom-header pr-1">Toimiala</v-col>
            <v-col cols="3" class="orders-custom-header pr-1">Toimialakoodi</v-col>
            <v-col cols="3" class="orders-custom-header pr-1">Liik. vaih.</v-col>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-row no-gutters>
            
            <v-col cols="1" class="orders-custom-header pr-1">Etunimi</v-col>
            <v-col cols="1" class="orders-custom-header pr-1">Sukunimi</v-col>
            <v-col cols="2" class="orders-custom-header pr-1">Puhelinumero</v-col>
            <v-col cols="3" style="" class="orders-custom-header pr-1">Sähköposti</v-col>
            <v-col v-if="selectedNewSalesTab === 'priorityLeads' || selectedNewSalesTab === 'leads' || selectedNewSalesTab === 'dataProcessing'" cols="1" class="orders-custom-header pr-1 text-center">Teht.nimike</v-col>
            <v-col v-if="selectedNewSalesTab === 'priorityLeads' || selectedNewSalesTab === 'leads' ||selectedNewSalesTab === 'dataProcessing'" cols="1" class="orders-custom-header pr-1 text-center">Tuote</v-col>
            <v-col v-if="selectedNewSalesTab !== 'priorityLeads'" cols="1" class="orders-custom-header pr-1 text-center">Avaukset</v-col>
            
            <!-- <v-col v-if="selectedNewSalesTab === 'readyForSend' || selectedNewSalesTab === 'dataProcessing'" cols="2" class="orders-custom-header pr-1"></v-col>
            <v-col v-if="selectedNewSalesTab === 'leads'" cols="1" class="orders-custom-header pr-1">@ Avaukset</v-col>
            <v-col v-if="selectedNewSalesTab === 'leads'" cols="1" class="orders-custom-header pr-1"></v-col> -->
            
            <v-col cols="2" class="orders-custom-header pr-1 text-center">
              <div>{{selectedNewSalesTab === 'leads' ? 'Myynnin status' : ''}}
              {{selectedNewSalesTab === 'readyForSend' ? 'Esikäsittelyn status' : ''}}
              {{selectedNewSalesTab === 'dataProcessing' ? 'Esikäsittelyn status' : ''}}
              </div>
              <div v-if="selectedNewSalesTab !== 'leads'" style="display:inline-block;position:relative;top:2px;" class="pr-1 "><input type="checkbox" :checked="allDataProcessingLeadsSelected" @change="v => updateBatchStatusForAllLeads('data_processing', v)" ></div>
              <select v-if="selectedNewSalesTab !== 'leads'" :value="batchPreparationStatus" class="status-select ml-1" :style="'width:80px;font-size:11px;'" @click.stop @change="v => updatePreparationStatusForBatch(v)">
                <option value=""></option>
                <option value="data_processing">Datan käsittely</option>
                <option value="ready_for_send">Valmis lähetykseen</option>
                <option value="priority_ready_for_contact">Priority liidi - Valmis kontaktointiin</option>
                

              </select>  
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div style="padding-top:135px;" >
        <v-lazy
          style="width:100%; padding:0px; margin:0px;min-height:15px;border-bottom:1px dotted #ccc;"
          :options="{threshold: .9}"
          v-for="l in getLeads" :key="l.id"
          
        >
          <div style="width:100%">
            <v-row no-gutters :style="'background:'+ statusColors[l.salesStatus]" class="py-1">
              <v-col cols="5">
                <v-row no-gutters>
                  <v-col cols="1" style="max-width:75px;padding-top:1px;" class="orders-custom-field pl-3 pr-1">
                    <div >
                      <span v-if="l.interactionsExist">
                        <i v-if="openedLeadIds[l.id]" @click="v => updateOpenedLeadIds(l.id, false)" class="pointer fas fa-chevron-down"></i>
                        <i v-else @click="v => updateOpenedLeadIds(l.id, true)" class="pointer fas fa-chevron-right"></i>
                      </span>
                      <span v-else  style="margin-left:10px"></span>
                      <i  @click="v => deleteLead(l.id)" class="pointer ml-1 far fa-trash-alt"></i>
                      <v-tooltip bottom content-class=''>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" >
                            <i :style="l.manuallyAdded ? 'color:#555' : 'color:transparent'" class="pointer ml-2 fas fa-user-circle"></i>
                          </span>
                        </template>
                        <span style="font-size:11px;">Liidi on manuaalisesti lisätty.</span>
                      </v-tooltip>
                      
                    </div>
                  </v-col>
                  <v-col cols="1" class="orders-custom-field pl-3 pr-1">{{l.salespersonName}}</v-col>
                  <v-col cols="2" class="orders-custom-field pr-1">{{l.companyName}}</v-col>
                  <v-col cols="1" class="orders-custom-field pr-1">{{l.companyId}}</v-col>
                  <v-col cols="1" class="orders-custom-field pr-1">{{l.companyForm}}</v-col>
                  <v-col cols="2" class="orders-custom-field pr-1">{{l.deliveryAddress}}</v-col>
                  <v-col cols="1" class="orders-custom-field pr-1">
                    <span><input :value="l.deliveryPostalCode" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'deliveryPostalCode',v)"></span>
                  </v-col>
                  <v-col cols="1" class="orders-custom-field pr-1">
                    <span><input :value="l.deliveryCity" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'deliveryCity',v)"></span>
                  </v-col>
                  <v-col cols="2" class="orders-custom-field pr-1">
                    <span><input :value="l.website" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'website',v)"></span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row no-gutters>
                  <v-col cols="2" class="orders-custom-field pr-1">{{l.staffNumber}}</v-col>
                  <v-col cols="4" class="orders-custom-field pr-1">
                    <span><input :value="l.industryCodeName" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'industryCodeName',v)"></span>
                  </v-col>
                  <v-col cols="3" class="orders-custom-field pr-1">
                    <span><input :value="l.industryCode" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'industryCode',v)"></span>
                  </v-col>
                  <v-col cols="3" class="orders-custom-field pr-1 text-center">{{l.revenue}}</v-col>
                </v-row>
              </v-col>
              <v-col cols="5">
                <v-row no-gutters>
                  
                  <v-col cols="1" class="orders-custom-field pr-2">
                    <span><input :value="l.firstName" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'firstName',v)"></span>
                  </v-col>
                  <v-col cols="1" class="orders-custom-field pr-1">
                    <span><input :value="l.lastName" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'lastName',v)"></span>
                  </v-col>
                  <v-col cols="2" class="orders-custom-field pr-1">
                    <span><input :value="l.contactPhone" type="text" class="lead-data-input-field" @change="v => updateField(l.id,'contactPhone',v)"></span>
                  </v-col>
                  <v-col cols="3" style="width:100%" class="orders-custom-field pr-1">
                    <span><input :value="l.contactEmail" type="text" style="width:100%" class="lead-data-input-field" @change="v => updateField(l.id,'contactEmail',v)"></span>
                  </v-col>
                  <v-col v-if="selectedNewSalesTab === 'leads' || selectedNewSalesTab === 'priorityLeads' || selectedNewSalesTab === 'dataProcessing'"  cols="1" class="orders-custom-field pr-1 text-center">
                    <span><input :value="l.contactRole" type="text" style="width:100%" class="lead-data-input-field" @change="v => updateField(l.id,'contactRole',v)"></span>
                  </v-col>
                  <v-col v-if="selectedNewSalesTab === 'leads' || selectedNewSalesTab === 'priorityLeads' || selectedNewSalesTab === 'dataProcessing'"  cols="1" class="orders-custom-field pr-1 text-center">
                    <span><input :value="l.productInterest" type="text" style="width:100%" class="lead-data-input-field" @change="v => updateField(l.id,'productInterest',v)"></span>
                  </v-col>
                  <v-col v-if="selectedNewSalesTab !== 'priorityLeads'" cols="1" class="orders-custom-field pr-1 text-center">{{l.email_1_opens}} <div style="font-size:7px;">{{l.latest_1_open ? ' ('+customFormatter(l.latest_1_open)+')' : ''}}</div></v-col>
                  
                  
                  
                  <v-col cols="2" class="orders-custom-field pr-3 text-center" v-if="selectedNewSalesTab === 'leads' || selectedNewSalesTab === 'priorityLeads'">
                    <select :value="l.salesStatus" class="status-select" style="max-width:100%;" @click.stop @change="status => changeLeadStatus(l.id,'salesStatus', status)">
                      <option value="not_contacted">Ei kontaktoitu</option>
                      <option value="called_no_answer">Soitettu - ei vastausta</option>
                      <option value="called_not_interested">Soitettu - ei kinnostunut</option>
                      <option value="meeting_booked">Tapaaminen saatu</option>
                      <option value="offer_sent">Tarjous lähetetty</option>
                      <option value="order_completed">Tilaus tehty</option>
                    </select>  
                  </v-col>
                  <v-col cols="2" class="orders-custom-field pr-3 text-center" v-if="selectedNewSalesTab === 'readyForSend' || selectedNewSalesTab === 'dataProcessing'">
                    <!-- appearance: none !important;border:none; -->
                    <div style="display:inline-block;position:relative;top:2px;" class="pr-2 "><input type="checkbox" :checked="batchUpdateLeadIds[l.id]" @change="v => updateBatchStatusForLeads(l.id, v)" ></div>
                    <select :value="l.preparationStatus" class="status-select" style="color:#000;font-size:11px;max-width:80%;" @click.stop @change="status => changeLeadStatus(l.id,'preparationStatus', status)">
                      <option value="data_processing">Datan käsittely</option>
                      <option value="ready_for_send">Valmis lähetykseen</option>
                      <option value="priority_ready_for_contact">Priority liidi</option>
                      <!-- <option value="email_sent">Sähköposti lähetetty</option> -->
                    </select>  
                  </v-col>
                  <!-- <v-col cols="1" class="orders-custom-field pr-3" v-if="selectedNewSalesTab === 'readyForSend' || selectedNewSalesTab === 'dataProcessing'">
                    <v-icon :size="16" style="padding-left:10px;padding-top:0px;">fas fa-list-alt</v-icon>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="openedLeadIds[l.id]">
              <div style="width:100%" class="ml-12">
                <div style="display:inline-block;min-width:70px;font-size:11px;font-weight:600;">@ numero</div>
                <div style="display:inline-block;min-width:75px;font-size:11px;font-weight:600;">Tapahtuma</div>
                <div style="display:inline-block;width:100px;font-size:11px;font-weight:600;">Päivämäärä</div>
              </div>
              <div class="ml-12 my-0" style="width:100%" v-for="(i,index) in getInteractionsForLead(l.id)" :key="l.id+'_interaction_'+index">
                <div style="display:inline-block;width:70px;font-size:11px;">{{i.emailNumber}}</div>
                <div style="display:inline-block;width:75px;font-size:11px;">{{eventNames[i.event] ? eventNames[i.event] : ''}}</div>
                <div style="display:inline-block;width:100px;font-size:11px;">{{i.interactionDate ? customFormatter(i.interactionDate) : ''}}</div>
                <div style="display:inline-block;width:20px;font-size:11px;" v-if="i.event === 'send' && leadsMap[l.id] && leadsMap[l.id]['email_'+i.emailNumber+'_content']">
                  <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" style="z-index:9999">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >
                        <v-icon :size="12" style="padding-left:10px;padding-top:0px;">fas fa-envelope-open-text</v-icon>
                      </span>
                    </template>
                    <div style="font-size:11px;background:#FFF;padding:10px;max-width:250px;">
                      <div style="font-weight:600;font-size:13px;">Sähköpostin sisältö</div>
                      <br>
                      {{leadsMap[l.id] && leadsMap[l.id]['email_'+i.emailNumber+'_content'] ?  leadsMap[l.id]['email_'+i.emailNumber+'_content'] : ''}}
                      
                    </div>
                  </v-menu>
                  
                </div>
              </div>
            </v-row>
          </div>
        </v-lazy>
      </div>
    </div>
    <AddLead />
  </v-container>  
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import firebase from 'firebase'
import dateFormat from 'dateformat'
import * as Papa from 'papaparse'
import shared from './../../shared'
import AddLead from './../../components/blocks/AddLead'

var db = null


export default {
    components: {
      quillEditor,
      AddLead
    },
     data() {
      return {
        sortColumn:'score',
        campaignsContactsUnsubscribe:null,
        campaignIdFilter:'',
        campaignContacts:{},
        allDataProcessingLeadsSelected:false,
        exportSalespersonFilter:'all',
        loadAsPriorityLeads:false,
        batchSalesperson:'',
        batchPreparationStatus:'',
        regionsSearch:'',
        leadsSearch:'',
        selectedNewSalesTab:"existingCustomers",
        batchUpdatePostalCodes:{},
        batchUpdateLeadIds:{},
        openedLeadIds:{},
        eventNames:{
          send:"Lähetys",
          open:"Avaus",
          click:"Klikkaus"
        },
        statusColors:{
          not_contacted:'inherit',
          called_no_answer:'#FFF3E0',
          called_not_interested:'#FFF3E0',
          meeting_booked:'#FFF3E0',
          offer_sent:'#FFF3E0',
          order_completed:'#E8F5E9',

        },
        listKey:5894,
        noteName:'',
        campaigns:[],
        leads:[],
        campaignsMap:{},
        leadsMap:{},
        configMap:{},
        config:[],
        headersRegions: [
          { text: 'Maakunta', value: 'stateName_fi', align: 'left', sortable: false },
          { text: 'Maakunta Ruotsiksi', value: 'stateName_se', align: 'left', sortable:true},
          { text: 'Maakuntakoodi', value: 'stateCode', align: 'left', sortable:false},
          { text: 'Kunta', value: 'districtName_fi', align: 'left', sortable:false},
          { text: 'Kunta Ruotsiksi', value: 'districtName_se', align: 'left', sortable:false},
          { text: 'Kunnan koodi', value: 'districtCode', align: 'left', sortable:false},
          { text: 'Postinumeron nimi', value: 'postalCodeName', align: 'left', sortable:false},
          { text: 'Postinumero', value: 'postalCode', align: 'left', sortable:false},
          { text: 'Myyjä', value: 'salesperson', align: 'left', sortable:false},
        ],
        headers: [
          //{ text: '#', value: 'number', align: 'left',},
          //{ text: '', value: 'select', align: 'center', sortable: false},
          { text: ' ', value: 'name', align: 'left', sortable: false },
          { text: 'Viimeisin aktiviteetti', value: 'latestInteraction', align: 'left', sortable:true},
          { text: 'Kontaktityyppi', value: 'leadOrContact', align: 'left', sortable: false },
          { text: 'Kaupunki', value: 'salesperson', align: 'left', sortable:false},
          { text: 'Yritys', value: 'companyName', align: 'left', sortable:false},
          { text: 'Kontakti', value: 'contactName', align: 'left', sortable:false},
          { text: 'Sähköposti', value: 'contactEmail', align: 'left', sortable:false},
          { text: 'Puhelinumero', value: 'contactPhone', align: 'left', sortable:false},
          { text: 'Lähetyksen pvm.', value: 'created_at', align: 'left', sortable:false},
          { text: 'Kampanja otsikko', value: 'subject', align: 'left', sortable:false},
          { text: 'Score', value: 'score', align: 'left', sortable:true},
          { text: 'Extras', value: 'extras', align: 'left', sortable:true},
          { text: 'Avaukset', value: 'opens', align: 'left', sortable:true},
          { text: 'Klikkaukset', value: 'clicks', align: 'left', sortable:true},
          { text: 'Status', value: 'status', align: 'left', sortable:false},
        ],
        
      }
    },
    watch: {
      campaignIdFilter:{
        handler(val){
          this.loadContactsForCampaign(false)
        }
      },
      showAsSales:{
        handler(val){
          this.quillKey = this.quillKey + 1
        },
      },
      selectedNote:{
        handler(val){
        },
      },
      allAccess:{
        handler(val){
          if(!val) this.selectedNote = 'W8lAhkDj6mTrQfWoocC2'
        },
      },
    },
    created() {
      this.exportContactsAndLeads = shared.exportContactsAndLeads
    },
    mounted() {
      db = firebase.firestore();
      this.initiateCampaigns()
      this.initiateConfig()
      this.initiateLeads()
      this.content = this.disabledContent
    },
    computed: {
      getLeadSplit(){
        var split = []
        var salespersons = {'all':{amount:0,salespersonName:'--Kaikki'}}
        this.getLeads.forEach(lead => {
          salespersons[lead.salesperson] ? salespersons[lead.salesperson].amount += 1 : salespersons[lead.salesperson] = {amount:1,salespersonName:lead.salespersonName}
          salespersons.all.amount += 1
          //split.push({salespersonName:salespersonName})
        })
        Object.keys(salespersons).forEach(salesperson => {
          split.push({...salespersons[salesperson],salesperson})
        })
        split.sort((a,b)=>{
          if(!a.salespersonName) return 0
          if(!b.salespersonName) return 0
          var salespersonNameA= a.salespersonName.toLowerCase(), salespersonNameB=b.salespersonName.toLowerCase();
          if (salespersonNameA > salespersonNameB) {return 1;}
          if (salespersonNameB > salespersonNameA) {return -1;}
          return 0;
        })
        return split
      },
      companyIdsOld(){
        var ids = {}
        Object.keys(this.companies).forEach(c => {
          var id = this.companies[c].companyId
          if(id) {
            id = id.replace("-","")
            ids[id] = true
          }
        })
        console.log(ids)
        return ids
      },
      companyIds(){
        var ids = {}
        Object.keys(this.companies).forEach(c => {
          var id = this.companies[c].companyId
          if(id) {
            id = id.replace("-","").trim()
            ids[id] = true
          }
        })
        return ids
      },
      companyAddresses(){
        var addresses = {}
        Object.keys(this.companies).forEach(c => {
          var address = this.companies[c].deliveryAddress
          var pc = this.companies[c].deliveryPostalCode
          if(address && pc) {
            address = address.toLowerCase().trim()
            pc = pc.toLowerCase().trim()
            addresses[address+'_'+pc] = true
          }
        })
        //console.log(ids)
        return addresses
      },
      leadCompanyIds(){
        var ids = {}
        Object.keys(this.leadsMap).forEach(c => {
          var id = this.leadsMap[c].companyId
          if(id) {
            id = id.replace("-","")
            ids[id] = c
          }
        })
        return ids
      },
      leadEmails(){
        var emails = {}
        Object.keys(this.leadsMap).forEach(c => {
          var email = this.leadsMap[c].contactEmail
          if(email) {
            email = email.trim()
            emails[email] = c
          }
        })
        return emails
      },
      leadPhoneNumbers(){
        var phoneNumbers = {}
        Object.keys(this.leadsMap).forEach(c => {
          var phoneNumber = this.leadsMap[c].contactPhone
          if(phoneNumber) {
            phoneNumber = phoneNumber.trim()
            phoneNumbers[phoneNumber] = c
          }
        })
        return phoneNumbers
      },
      leadCompanyAddresses(){
        var ids = {}
        Object.keys(this.leadsMap).forEach(c => {
          var id = this.leadsMap[c].companyId
          if(id) {
            id = id.replace("-","")
            ids[id] = c
          }
        })
        return ids
      },
      getSalespersonsFilter(){
        var staff = this.staff
        var salespersons = [{text:'--Kaikki--', id:'all'}]
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = [{text:'Valitse myyjä', id:''}]
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) {
            salespersons.push({id:key,text:this.staff[key].firstName, })
          }
        }
        return salespersons
      },
      anuTomiMiko(){
        return this.user.uid === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2' || this.user.uid === 'wcMZF1c4vsMZAmCsXzSDDwh4PJd2' || this.user.uid === 'gRkaRl92OGXQIzaJy9E0YiOKgSf1' ? true: false
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getSalesRegions(){
        var arr = []
        if(!this.configMap['sales_regions']) return arr
        var pcs = this.configMap['sales_regions'].postalCodes
        var states = this.configMap['sales_regions'].states
        var districts = this.configMap['sales_regions'].districts

        Object.keys(pcs).forEach(code => {
          var pc = pcs[code]
          var obj = {
            stateName_fi:states[pc.stateCode].name_fi,
            stateName_se:states[pc.stateCode].name_se,
            stateCode:pc.stateCode,
            districtName_fi:districts[pc.districtCode].name_fi,
            districtName_se:districts[pc.districtCode].name_se,
            districtCode:pc.districtCode,
            postalCodeName:pc.name_fi,
            postalCode:pc.code,
            salesperson:pc.salesperson,
            combo:states[pc.stateCode].name_fi+'_'+districts[pc.districtCode].name_fi+'_'+pc.code
          }
          var salespersonName = this.staff[pc.salesperson] ? this.staff[pc.salesperson].firstName : ''
          if (this.regionsSearch !== ""){
            var searchText = ''
            searchText += states[pc.stateCode].name_fi.toLowerCase()+'_'+districts[pc.districtCode].name_fi.toLowerCase()+'_'+pc.name_fi.toLowerCase()
            searchText += pc.stateCode+'_'+pc.districtCode+pc.code+'_'+salespersonName
            if(searchText.toLowerCase().includes(this.regionsSearch.toLowerCase())) arr.push(obj)
          }
          else {arr.push(obj)}
        })
        arr.sort((a,b)=>{
          if(!a.combo) return 0
          if(!b.combo) return 0
          var comboA= a.combo.toLowerCase(), comboB=b.combo.toLowerCase();
          if (comboA > comboB) {return 1;}
          if (comboB > comboA) {return -1;}
          return 0;
        })

        return arr

      },
      getLeads(){
        var arr = []
        var tab = this.selectedNewSalesTab      

        Object.keys(this.leadsMap).forEach(id => {
          var l = this.leadsMap[id]
          var pc = l.deliveryPostalCode ? l.deliveryPostalCode.trim() : ''
          var length = pc.length
          if (length == 4) pc = '0' + pc
          if (length == 3) pc = '00' + pc
          var salesperson = ''
          var salespersonName = ''
          //console.log(l)
          if(l.salesperson) salesperson = l.salesperson
          else if(this.configMap['sales_regions'] && this.configMap['sales_regions'].postalCodes && this.configMap['sales_regions'].postalCodes[pc]) salesperson = this.configMap['sales_regions'].postalCodes[pc].salesperson
          if(salesperson && this.staff[salesperson]) salespersonName = this.staff[salesperson].firstName 
          
          if(!this.allAccess && salesperson !== this.user.uid) return

          var okToContinue = false
          if(tab === 'leads' && (l.preparationStatus === 'email_sent' || l.preparationStatus === 'ready_for_contact') ) okToContinue = true
          if(tab === 'dataProcessing' && l.preparationStatus === 'data_processing') okToContinue = true
          if(tab === 'readyForSend' && (l.preparationStatus === 'ready_for_send')) okToContinue = true
          if(tab === 'priorityLeads' && (l.preparationStatus === 'priority_ready_for_contact')) okToContinue = true
          
          if(!okToContinue) return
          var obj = {
            id,
            companyName:l.companyName,
            companyId:l.companyId,
            companyForm:l.companyForm,
            deliveryAddress:l.deliveryAddress,
            deliveryCity:l.deliveryCity,
            deliveryPostalCode:pc,
            website:l.website,
            firstName:l.firstName ? l.firstName : '',
            lastName:l.lastName ? l.lastName : '',
            contactPhone:l.contactPhone,
            contactEmail:l.contactEmail,
            contactRole:l.contactRole ? l.contactRole : '',
            email_1_opens:l.email_1_opens ? l.email_1_opens : 0,
            companyRegistrationDate:l.companyRegistrationDate,
            industryCode:l.industryCode,
            industryCodeName:l.industryCodeName,
            vainuLink:l.vainuLink,
            staffNumber:l.staffNumber,
            revenue:l.revenue,
            message:l.message,
            source:l.source,
            manuallyAdded: l.manuallyAdded ? true : false,
            productInterest:l.productInterest,
            preparationStatus:l.preparationStatus,
            salesStatus:l.salesStatus,
            salespersonName,
            salesperson,
            latest_1_open:l.latest_1_open ? l.latest_1_open : '',
            interactionsExist:l.interactions ? true :false
          }
          if (this.leadsSearch !== ""){
            var searchText = ''
            searchText += obj.salespersonName+'_'+obj.companyName+'_'+obj.companyId+'_'+obj.contactName+'_'+obj.contactEmail+'_'+obj.industryCode+'_'+obj.industryCodeName
            if(searchText.toLowerCase().includes(this.leadsSearch.toLowerCase())) arr.push(obj)
          }
          else {arr.push(obj)}
        })
        if(this.selectedNewSalesTab === 'priorityLeads'){
          arr.sort((a,b)=>{
            var at = a.salespersonName + '_' + a.companyName
            var bt = b.salespersonName + '_' + b.companyName
            if (at > bt) {return 1;}
            if (bt > at) {return -1;}
            return 0;
          })
        }
        else {
          arr.sort((a,b)=>{
            var aOpens = 1000- (a.email_1_opens ? a.email_1_opens + 1 : 1)
            var bOpens = 1000- (b.email_1_opens ? b.email_1_opens + 1 : 1)
            /* var aOpens = a.email_1_opens
            if(a.email_1_opens.toString().length == 1) aOpens = '00' + a.email_1_opens
            if(a.email_1_opens.toString().length == 2) aOpens = '0' + a.email_1_opens
            var bOpens = b.email_1_opens
            if(b.email_1_opens.toString().length == 1) bOpens = '00' + b.email_1_opens
            if(b.email_1_opens.toString().length == 2) bOpens = '0' + b.email_1_opens */
            var at = a.salespersonName + '_' + aOpens
            var bt = b.salespersonName + '_' + bOpens
            if (at > bt) {return 1;}
            if (bt > at) {return -1;}
            return 0;
          })
        }
        /* 
        var aPrio = a.prio_level ? a.prio_level : 0
          var bPrio = b.prio_level ? b.prio_level : 0
          return bPrio - aPrio
           */
        

        return arr

      },
      getCampaignArrayForFilter(){
        var arr = []
        this.campaigns.forEach(c => {
          var sendDate = c.sendDate
          sendDate = this.customFormatter(sendDate)
          arr.push({text:sendDate + ' ' + c.subject, id:c.id})
        })

        arr = arr.sort((a,b)=>{
          var nameA = a.text.toLowerCase().trim(), nameB= b.text.toLowerCase().trim();
          if (nameA < nameB) {return 1;}
          if (nameB < nameA) {return -1;}
          return 0;
        })
        return arr
        
      },
      getCampaignContacts(){ 
        var campaigns = this.campaigns
        var campaignContacts = this.campaignContacts
        
        var contacts = this.contacts
        var companies = this.companies
        var leads = this.leadsMap
        var arr = []
        
        if(!this.campaignsMap[this.campaignIdFilter]) return arr

        var c = this.campaignsMap[this.campaignIdFilter]

        //console.log(campaignContacts)

        Object.keys(campaignContacts).forEach(cId => {
          var cc = campaignContacts[cId]
            
          var split = cId.split("__")
          var contactType = split[0]
          var contactOrLeadId = split[1]
          var companyName = ''
          var deliveryCity = ''
          var contactName = ''
          var contactEmail = ''
          var contactPhone = ''
          var salesperson = ''

          

          if(contactType === 'lead'){
            if(leads[contactOrLeadId]){
              var l = leads[contactOrLeadId]
              companyName = l.companyName
              deliveryCity = l.deliveryCity
              contactName = l.firstName + ' ' + l.lastName
              contactEmail = l.contactEmail
              contactPhone = l.contactPhone
              salesperson = ''
            }
          }
          else if(contactType === 'contact'){
            if(contacts[contactOrLeadId]){
              
              var contact = contacts[contactOrLeadId]
              if(contact.companyId && companies[contact.companyId]){
                companyName = companies[contact.companyId].companyName
                deliveryCity = companies[contact.companyId].deliveryCity
              }
              else{
                companyName = ''
                deliveryCity = ''
              }
              contactName = contact.firstName + ' ' + contact.lastName
              contactEmail = contact.email
              contactPhone = contact.phone
              salesperson = ''//contacts[contactOrLeadId] && companies[contacts[contactOrLeadId].companyId] ? companies[contacts[contactOrLeadId].companyId].salesperson : ''
            }
          }
          var scores = this.getScoreForCamapaignContact(cc,contactEmail)

          arr.push({
            id:c.id+cId,
            contactType,
            campaignId:c.id,
            contactId:cId,
            sendDate:c.sendDate,
            subject:c.subject,
            latestInteraction:cc.latestInteraction ? cc.latestInteraction : '',
            latestInteractionDate:cc.latestInteractionDate ? cc.latestInteractionDate : '',
            companyName,
            salesperson,
            deliveryCity,
            contactName,
            contactEmail,
            contactPhone,
            opens:cc.opens,
            scores,
            clicks:cc.clicks,
            status:cc.status ? cc.status : 'not_contacted'
          })
        })
        
        /* campaigns.forEach(c => {
          Object.keys(c.results).forEach(cId => {
            if(!contacts[cId]) return
            var salesperson = companies[contacts[cId].companyId] ? companies[contacts[cId].companyId].salesperson : ''
            if(!this.staff[this.user.uid].isAdmin && this.staff[this.user.uid].role == 'sales' && this.user.uid !== salesperson) return // REMOVE NON-OWN CAMPAIGN CONTACTS
            
            //console.log({campaignIdFilter:this.campaignIdFilter, cId})
            if(this.campaignIdFilter && this.campaignIdFilter !== c.id) return

            arr.push({
              id:c.id+cId,
              campaignId:c.id,
              contactId:cId,
              sendDate:c.sendDate,
              subject:c.subject,
              latestInteraction:c.results[cId].latestInteraction ? c.results[cId].latestInteraction : '',
              latestInteractionDate:c.results[cId].latestInteractionDate ? c.results[cId].latestInteractionDate : '',
              companyName:companies[contacts[cId].companyId] ? companies[contacts[cId].companyId].companyName : '',
              salesperson,
              contactName:contacts[cId].firstName + ' ' + contacts[cId].lastName,
              contactEmail:contacts[cId].email,
              contactPhone:contacts[cId].phone,
              opens:c.results[cId].opens,
              clicks:c.results[cId].clicks,
              status:c.results[cId].status ? c.results[cId].status : 'not_contacted'
            })
          })
        }) */
        if(this.sortColumn === 'latestInteraction'){
          arr = arr.sort((a,b) => {
            var aDate = 0
            var bDate = 0
            
            if(a.latestInteractionDate && a.latestInteractionDate._seconds){
              var aDate = new Date(a.latestInteractionDate._seconds * 1000)
            }
            if(a.latestInteractionDate && a.latestInteractionDate.seconds){
              var aDate = new Date(a.latestInteractionDate.seconds * 1000)
            }
            if(b.latestInteractionDate && b.latestInteractionDate._seconds){
              var bDate = new Date(b.latestInteractionDate._seconds * 1000)
            }
            if(b.latestInteractionDate && b.latestInteractionDate.seconds){
              var bDate = new Date(b.latestInteractionDate.seconds * 1000)
            }

            return  bDate - aDate
          })
        }
        else if(this.sortColumn === 'score'){
          arr = arr.sort((a,b) => {
            return b.scores.score - a.scores.score
          })
        }
        else if(this.sortColumn === 'opens'){
          arr = arr.sort((a,b) => {
            return b.opens - a.opens
          })
        }
        else if(this.sortColumn === 'clicks'){
          arr = arr.sort((a,b) => {
            return b.clicks - a.clicks
          })
        }

        return arr


      },
      ...mapFields({
        settings:"settings",
        device:"device",
        contacts:"contact.contacts",
        orders:"order.orders",
        companies:"company.companies",
        staff:"staff.staff",
        user:"user",
        newLeadModalVisible:"modals.additionalSales.newLead.visible",
      }),
    },
    methods: {
      getScoreForCamapaignContact(cc,email){
        var score = 0
        var extras = 0
        var clickPointMultiplier = 2
        
        var interactionDates = {}
        var clickSeconds = {}
        var openSeconds = {}
        cc.interactions.forEach(i => {
          if(i.interactionDate && i.interactionDate.seconds){
            if(i.event === 'open')  openSeconds[i.interactionDate.seconds] ? openSeconds[i.interactionDate.seconds] += 1 : openSeconds[i.interactionDate.seconds] = 1
            if(i.event === 'click') clickSeconds[i.interactionDate.seconds] ? clickSeconds[i.interactionDate.seconds] += 1 : clickSeconds[i.interactionDate.seconds] = 1
          }
          
          if(i.event !== 'open') return
          var date = this.customFormatter(i.interactionDate, true)
          
          interactionDates[date] ? interactionDates[date] += 1 : interactionDates[date] = 1
        })
        if(email === 'arto.sahlstrom@sahkorami.fi'){
          console.log({interactionDates})
            
        }
        
        score += Object.keys(openSeconds).length
        score += Object.keys(clickSeconds).length * clickPointMultiplier

        var numOfInteractionDates = Object.keys(interactionDates).length

        if(numOfInteractionDates > 1) {score += 5; extras += 5}
        if(numOfInteractionDates > 2) {score += 10; extras += 10}
        
        return {score,extras}
      },
      deleteLead(id){
        var t = this
        if (confirm('Haluatko varmasti poistaa liidin?')) {
          db.collection('leads').doc(id).delete().then(function() {
            t.batchUpdateLeadIds ={}
            t.openedLeadIds = {}
            t.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Liidi poistettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }).catch(function(error) {
              console.error("Error removing document: ", error);
          });
        }
        
      },
      updateBatchStatusForAllLeads(status, v){
        var v = v.target.checked
        this.allDataProcessingLeadsSelected = v
        var batchUpdateLeadIds = JSON.parse(JSON.stringify(this.batchUpdateLeadIds))
        
        Object.keys(this.leadsMap).forEach(lId =>{
          var l = this.leadsMap[lId]
          if (l.preparationStatus === status){
            if (v) batchUpdateLeadIds[lId] = true    
            else if (!v && batchUpdateLeadIds[lId]) delete batchUpdateLeadIds[lId]
          }
        })

        
        this.batchUpdateLeadIds = batchUpdateLeadIds
      },
      updateOpenedLeadIds(id, value){
        var openedLeadIds = JSON.parse(JSON.stringify(this.openedLeadIds))
        if(openedLeadIds[id]) delete openedLeadIds[id]
        else openedLeadIds[id] = true
        this.openedLeadIds = openedLeadIds
      },
      updateField(id,field,v){
        //console.log({id,field,v:v.target.value})
        var value = null
        var t = this
        v && v.target && v.target.value ? value = v.target.value : null
        if(value !== undefined || value !== null){
          db.collection('leads').doc(id).set({ 
            [field]:value
          }, { merge: true })
          .then(function() {
            t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          })
        }
        else {
          alert("Virheellinen arvo")
          console.log("Virheellinen arvo")
        }
      },
      changeLeadStatus(id,field, status){
        var t = this
        var val = status.target.value
        db.collection('leads').doc(id).set({ 
          [field]:val
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      updateSalespersonForBatch(v){
        var salesperson = v.target.value
        var postalCodes = JSON.parse(JSON.stringify(this.configMap['sales_regions'].postalCodes))
        Object.keys(this.batchUpdatePostalCodes).forEach(code => {
          postalCodes[code].salesperson = salesperson
        })
        console.log(salesperson)
        var t = this
        db.collection('config').doc('sales_regions').set({ 
          postalCodes
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
        this.batchUpdatePostalCodes = {}
      },
      updatePreparationStatusForBatch(v){
        var status = v.target.value
        if(!status){
          alert("Valitse status")
          return
        }
        var batch = db.batch();
        var t = this
        Object.keys(this.batchUpdateLeadIds).forEach(key => {
          var leadRef = db.collection('leads').doc(key)
          batch.set(leadRef, { 
            preparationStatus:status
          }, { merge: true })
        })
        batch.commit().then(() => {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        });
        this.allDataProcessingLeadsSelected = false
        this.batchPreparationStatus = ''
        this.batchUpdateLeadIds = {}
      },
      updateSalespersonForPostalCode(postalCode,v){
        var postalCodes = JSON.parse(JSON.stringify(this.configMap['sales_regions'].postalCodes))
        postalCodes[postalCode].salesperson = v.target.value
        console.log(v.target.value)
        
        var t = this
        db.collection('config').doc('sales_regions').set({ 
          postalCodes
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      updateBatchStatusForItem(id,v){
        console.log(v)
        var batchUpdatePostalCodes = JSON.parse(JSON.stringify(this.batchUpdatePostalCodes))
        if(batchUpdatePostalCodes[id]) delete batchUpdatePostalCodes[id]
        else batchUpdatePostalCodes[id] = true
        this.batchUpdatePostalCodes = batchUpdatePostalCodes
      },
      updateBatchStatusForLeads(id,v){
        var batchUpdateLeadIds = JSON.parse(JSON.stringify(this.batchUpdateLeadIds))
        if(batchUpdateLeadIds[id]) delete batchUpdateLeadIds[id]
        else batchUpdateLeadIds[id] = true
        this.batchUpdateLeadIds = batchUpdateLeadIds
      },
      changeStatus(campaignId,contactId,status){
        console.log(campaignId,contactId,status)
        var t = this
        db.collection('campaigns').doc(campaignId).collection('contacts').doc(contactId).set({ 
          status:status.target.value
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      changeStatusOLD(campaignId,contactId,status){
        var results = JSON.parse(JSON.stringify(this.campaignsMap[campaignId].results))
        results[contactId].status = status.target.value
        var t = this
        db.collection('campaigns').doc(campaignId).set({ 
          results
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      saveRegions(states,districts,postalCodes){
        var t = this
        db.collection('config').doc('sales_regions').set({ 
          states,
          districts,
          postalCodes
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      getLatestInteraction(item){
        console.log(item)
        var interactions = this.getInteractions(item.campaignId,item.contactId)
        console.log(interactions)
        var event = this.eventNames[interactions[0].event] ? this.eventNames[interactions[0].event] : ''
        var date = ""
        try {date = this.customFormatter(interactions[0].interactionDate)} catch(e){}
        return event + ' - ' + date
      },
      getInteractionsForLead(id){
        var arr = []//this.campaignsMap[campaignId].results[contactId].interactions
        if(!this.leadsMap[id] || !this.leadsMap[id].interactions) return
        this.leadsMap[id].interactions.forEach(i => {
          arr.push({
            interactionDate:i.interactionDate,
            event:i.event,
            emailNumber:i.emailNumber
          })
        })
        return arr.sort((a,b)=>{
          var aDate = 0
          var bDate = 0
          if(a.interactionDate && a.interactionDate._seconds){var aDate = new Date(a.interactionDate._seconds * 1000)}
          if(a.interactionDate && a.interactionDate.seconds){var aDate = new Date(a.interactionDate.seconds * 1000)}
          if(b.interactionDate && b.interactionDate._seconds){var bDate = new Date(b.interactionDate._seconds * 1000)}
          if(b.interactionDate && b.interactionDate.seconds){var bDate = new Date(b.interactionDate.seconds * 1000)}
          return  bDate - aDate
        })
      },
      getInteractions(campaignId,contactId){
        var arr = []//this.campaignsMap[campaignId].results[contactId].interactions
        this.campaignContacts[contactId].interactions.forEach(i => {
          arr.push({
            interactionDate:i.interactionDate,
            event:i.event,
            url:i.url ? i.url : ''
          })
        })
        return arr.sort((a,b)=>{
          var aDate = 0
          var bDate = 0
          if(a.interactionDate && a.interactionDate._seconds){var aDate = new Date(a.interactionDate._seconds * 1000)}
          if(a.interactionDate && a.interactionDate.seconds){var aDate = new Date(a.interactionDate.seconds * 1000)}
          if(b.interactionDate && b.interactionDate._seconds){var bDate = new Date(b.interactionDate._seconds * 1000)}
          if(b.interactionDate && b.interactionDate.seconds){var bDate = new Date(b.interactionDate.seconds * 1000)}
          return  bDate - aDate
        })
      },
      customFormatter(date,simple) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          if(simple) return dateFormat(myDate, "yyyy-mm-dd")
          else return dateFormat(myDate, "yyyy-mm-dd HH:MM:ss")
        }
        if (date._seconds) {
          var myDate = new Date(date._seconds*1000);
          if(simple) return dateFormat(myDate, "yyyy-mm-dd")
          else return dateFormat(myDate, "yyyy-mm-dd HH:MM:ss")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      createCampaignsArray(){
        var t = this
        var result = Object.keys(this.campaignsMap).reduce(function(result, noteId) {
          result.push({...t.campaignsMap[noteId]});
          return result;
        }, []);
        this.campaigns = result
      },
      createLeadsArray(){
        var t = this
        var result = Object.keys(this.leadsMap).reduce(function(result, leadId) {
          result.push({...t.leadsMap[leadId]});
          return result;
        }, []);
        this.leads = result
      },
      loadContactsForCampaign(firstLoad){
        var campaigns = this.getCampaignArrayForFilter
        var cId = null
        var t = this
        if(firstLoad){
          console.log("IN FIRST LOAD OF CONTACTS")
          var firstCampaign = campaigns[0]
          cId = firstCampaign.id
          this.campaignIdFilter = cId
        }
        else if (this.campaignIdFilter){
          cId = this.campaignIdFilter
        } 

        if(cId){
          if(this.campaignsContactsUnsubscribe) {
            console.log("CLOSING PREVIOUS CAMPAIGN CONTACTS")
            this.campaignsContactsUnsubscribe()
          }
          console.log("LOADING CAMPAIGN CONTACTS")
          this.campaignsContactsUnsubscribe = db.collection("campaigns").doc(cId).collection('contacts').onSnapshot(function(querySnapshot) {
              var campaignContacts = {}
              console.log("UPDATING CAMPAIGN CONTACTS FOR CAMPAIGN ", cId)
              querySnapshot.forEach(function(doc) {
                  campaignContacts[doc.id] = {...doc.data(),id:doc.id}
                  
              });
              t.campaignContacts = campaignContacts
          })
        }
      },
      initiateCampaigns(){
        var t = this
        var campaignsLoaded = false
        db.collection("campaigns")
        .onSnapshot(function(querySnapshot) {
            t.campaignsMap = {}
            querySnapshot.forEach(function(doc) {
                t.campaignsMap[doc.id] = {...doc.data(),id:doc.id}
            });
            t.createCampaignsArray()
            if(!campaignsLoaded){
              campaignsLoaded = true
              console.log("CAMPAIGNS NOT LOADED")
              t.loadContactsForCampaign(true)
            }
        })
      },
      initiateLeads(){
        var t= this
        db.collection("leads")
        .onSnapshot(function(querySnapshot) {
            t.leadsMap = {}
            querySnapshot.forEach(function(doc) {
                t.leadsMap[doc.id] = {...doc.data(),id:doc.id}
            });
            t.createLeadsArray()
        })
      },
      initiateConfig(){
        var t= this
        db.collection("config")
        .onSnapshot(function(querySnapshot) {
            t.configMap = {}
            querySnapshot.forEach(function(doc) {
                t.configMap[doc.id] = {...doc.data(),id:doc.id}
            });
        })
      },
      batchCreateLeads(leads){
        var t = this
        return new Promise(async function(resolve, reject) {
          try{
            if(leads.length <= 500){
              var batch = db.batch();
              for (var i = 0; i < leads.length; i++){
                //console.log(leads[i])
                var leadRef = db.collection('leads').doc()
                const leadId = leadRef.id
                batch.set(leadRef,{
                  id:leadId,  
                  ...leads[i]
                })
              }
              batch.commit().then(() => {
                t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
                resolve(true)
              });
            }
            else {
              alert("Max 500 liidiä kerralla")
              resolve(false)
            }
          }
          catch(e){
            resolve(false)
          }
        })
      },
      batchUpdateLeads(leads){
        var t = this
        return new Promise(async function(resolve, reject) {
          try{
            if(leads.length <= 500){
              var batch = db.batch();
              for (var i = 0; i < leads.length; i++){
                //console.log(leads[i])
                var id = leads[i].id
                if(id){
                  /* console.log(id)
                  console.log(leads[i].firstName) */
                  var leadRef = db.collection('leads').doc(id)
                  batch.set(leadRef, { 
                    ...leads[i]
                  }, { merge: true })
                }
                
              }
              batch.commit().then(() => {
                t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
                resolve(true)
              });
            }
            else {
              alert("Max 500 liidiä kerralla")
              resolve(false)
            }
          }
          catch(e){
            resolve(false)
          }
        })
      },
      
      getColumn(field, row){
        var columnNumber = null
        row.forEach((value,index) => {
          if(value === 'Yritys' && field === 'companyName') columnNumber = index
          else if (value === 'Y-tunnus' && field === 'companyId') columnNumber = index
          else if (value === 'Yhtiömuoto' && field === 'companyForm') columnNumber = index
          else if (value === 'Käyntiosoite' && field === 'deliveryAddress') columnNumber = index
          else if (value === 'Käyntipostinumero' && field === 'deliveryPostalCode') columnNumber = index
          else if (value === 'Käyntipostitoimipaikka' && field === 'deliveryCity') columnNumber = index
          else if (value === 'WWW-osoite' && field === 'website') columnNumber = index
          if (value === 'Etunimi' && field === 'firstName') columnNumber = index
          //else if (value === 'Email' && field === 'firstName') columnNumber = index
          if (value === 'Sukunimi' && field === 'lastName') columnNumber = index
          if (value === 'Tuote' && field === 'product') columnNumber = index
          //else if (value === 'Email' && field === 'lastName') columnNumber = index

          else if (value === 'Puhelin' && field === 'contactPhone' && !columnNumber) columnNumber = index
          else if (value === 'Email' && field === 'contactEmail' && !columnNumber) columnNumber = index
          else if (value === 'Tehtävänimike' && field === 'contactRole' && !columnNumber) columnNumber = index
          else if (value === 'Yrityksen rekisteröimispäivä'  && field === 'companyRegistrationDate') columnNumber = index
          else if (value === 'Toimiala'  && field === 'industryCode') columnNumber = index
          else if (value === 'Toimiala'  && field === 'industryCodeName') columnNumber = index
          else if (value === 'Linkki Vainuun'  && field === 'vainuLink') columnNumber = index
          else if (value === 'Henkilöstömäärä (viimeisin)'  && field === 'staffNumber') columnNumber = index
          else if (value === 'Liikevaihto (viimeisin) EUR'  && field === 'revenue') columnNumber = index
          
        })
        return columnNumber
      },

      async importProspects(){
        var ok = await this.importLeadsWithEncoder('UTF-8')
        if (!ok) {
          console.log("INVALID ENCODING")
          var ok2 = await this.importLeadsWithEncoder('ISO-8859-1')
          if(!ok2){
            alert("Ladatun tiedoston kentistä ei löydy vähintään seuraavia sarakkeita: Email, Puhelin, Yritys, Y-tunnus")
          }
          console.log(ok2 ? 'SECOND ENCODING WORKED' : 'NO ENCODING MATCH')
        } 

      },
      importLeadsWithEncoder(encoding){
        var t = this
        return new Promise(async function(resolve, reject) {
          try {
            var companyIds = t.companyIds
            //var companyIds = t.companyIdsOld
            var companyAddresses = t.companyAddresses
            var leadCompanyIds = t.leadCompanyIds
            var leadEmails = t.leadEmails
            var leadPhoneNumbers = t.leadPhoneNumbers
            var invalidContactDetails = ''
            var invalidCompanyNames = ''
            var invalidCompanyIds = ''
            var rows = 0
            var leads = []
            var mapping = {
              companyName:null,
              companyId:null,
              companyForm:null,
              deliveryAddress:null,
              deliveryPostalCode:null,
              deliveryCity:null,
              website:null,
              firstName:null,
              lastName:null,
              contactPhone:null,
              contactEmail:null,
              contactRole:null,
              companyRegistrationDate:null,
              industryCode:null,
              industryCodeName:null,
              vainuLink:null,
              staffNumber:null,
              revenue:null
            }
            var encodingOk = false
            var fieldsOk = false
            var existingLeads = []
            var processedContactEmails = {}
            Papa.parse(fileInputProspects.files[0], {
              encoding,
              step: function(row) {
                if(rows == 0){
                  mapping.companyName = t.getColumn('companyName', row.data)
                  mapping.companyId = t.getColumn('companyId', row.data)
                  mapping.companyForm = t.getColumn('companyForm', row.data)
                  mapping.deliveryAddress = t.getColumn('deliveryAddress', row.data)
                  mapping.deliveryPostalCode = t.getColumn('deliveryPostalCode', row.data)
                  mapping.deliveryCity = t.getColumn('deliveryCity', row.data)
                  mapping.website = t.getColumn('website', row.data)
                  mapping.firstName = t.getColumn('firstName', row.data)
                  mapping.lastName = t.getColumn('lastName', row.data)
                  mapping.contactPhone = t.getColumn('contactPhone', row.data)
                  mapping.contactEmail = t.getColumn('contactEmail', row.data)
                  mapping.contactRole = t.getColumn('contactRole', row.data)
                  mapping.companyRegistrationDate = t.getColumn('companyRegistrationDate', row.data)
                  mapping.industryCode = t.getColumn('industryCode', row.data)
                  mapping.industryCodeName = t.getColumn('industryCodeName', row.data)
                  mapping.vainuLink = t.getColumn('vainuLink', row.data)
                  mapping.staffNumber = t.getColumn('staffNumber', row.data)
                  mapping.revenue = t.getColumn('revenue', row.data)
                  mapping.product = t.getColumn('product', row.data)
                  
                  if(mapping.deliveryAddress) {encodingOk = true}
                  if(mapping.companyName !== null && mapping.contactEmail && mapping.deliveryAddress && mapping.companyId) {fieldsOk = true}
                  
                  console.log(mapping)  
                }
                else if (encodingOk && fieldsOk) {
                  var existingCustomer = false
                  var existingLead = false
                  var existingLeadId = ''
                  var alreadyProcessedEmail = false
                  var source = vainuLink ? "vainu" : ''

                  var companyName = row.data[mapping.companyName] ?  row.data[mapping.companyName] :''
                  var companyId = row.data[mapping.companyId] ? row.data[mapping.companyId] : ''
                  var email = row.data[mapping.contactEmail] ? row.data[mapping.contactEmail] : ''
                  var companyIdSimple = companyId ? companyId.trim().replace("-","") : ''
                  if(companyIds[companyIdSimple]) {existingCustomer = true}
                  //if(leadCompanyIds[companyIdSimple]) {existingLead = true}
                  if(leadEmails[email]) {existingLead = true; existingLeadId = leadEmails[email]}
                  
                  
                  var companyForm = row.data[mapping.companyForm] ?  row.data[mapping.companyForm] : ''
                  var deliveryAddress = row.data[mapping.deliveryAddress] ? row.data[mapping.deliveryAddress] : ''
                  var deliveryPostalCode = row.data[mapping.deliveryPostalCode] ? row.data[mapping.deliveryPostalCode] :''
                  deliveryPostalCode = deliveryPostalCode ? deliveryPostalCode.toLowerCase().trim() : ''
                  var deliveryAddressSimple = deliveryAddress ? deliveryAddress.toLowerCase().trim() : ''
                  if(companyAddresses[deliveryAddressSimple+'_'+deliveryPostalCode]) {existingCustomer = true}

                  var length = deliveryPostalCode.length
                  if (length == 4) deliveryPostalCode = '0' + deliveryPostalCode
                  if (length == 3) deliveryPostalCode = '00' + deliveryPostalCode
                  var deliveryCity = row.data[mapping.deliveryCity] ? row.data[mapping.deliveryCity] : ''
                  var website = row.data[mapping.website] ? row.data[mapping.website] :''
                  var firstName = row.data[mapping.firstName] ? row.data[mapping.firstName] : ''
                  var lastName = row.data[mapping.lastName] ? row.data[mapping.lastName] : ''
                  if(source === 'vainu' && !firstName) firstName = email

                  if(firstName.includes('@')) {
                    var split = firstName.split('@')
                    var splitFirstPart = split[0].split('.')
                    firstName = splitFirstPart[0] ? splitFirstPart[0]: ''
                    lastName = splitFirstPart[1] ? splitFirstPart[1]: ''
                  }
                  var contactPhone = row.data[mapping.contactPhone] ? row.data[mapping.contactPhone] : ''
                  if(leadPhoneNumbers[contactPhone]) {existingLead = true; existingLeadId = leadPhoneNumbers[contactPhone]}

                  var contactEmail = row.data[mapping.contactEmail] ? row.data[mapping.contactEmail] :''
                  var contactRole = row.data[mapping.contactRole] ? row.data[mapping.contactRole] :''
                  if(contactEmail && processedContactEmails[contactEmail]) {alreadyProcessedEmail = true}
                  if(contactEmail) processedContactEmails[contactEmail] = true
                  var companyRegistrationDate = row.data[mapping.companyRegistrationDate] ? row.data[mapping.companyRegistrationDate] : ''
                  var industryCode = row.data[mapping.industryCode] ? row.data[mapping.industryCode] : ''
                  var industryCodeName = row.data[mapping.industryCodeName] ? row.data[mapping.industryCodeName] : ''
                  if(industryCodeName.includes('(')) {
                    var split = industryCodeName.split('(')
                    industryCodeName = split[0] ? split[0].trim() : ''
                    industryCode = split[1] ? split[1].replace(')','').replace('(','').trim() : ''
                  }
                  var vainuLink = row.data[mapping.vainuLink] ? row.data[mapping.vainuLink] : ''
                  var productInterest = row.data[mapping.product] ? row.data[mapping.product] : ''
                  var staffNumber = row.data[mapping.staffNumber] ? row.data[mapping.staffNumber] : ''
                  var revenue = row.data[mapping.revenue] ? row.data[mapping.revenue] : ''

                  deliveryAddress = deliveryAddress ? deliveryAddress.toLowerCase().charAt(0).toUpperCase() + deliveryAddress.toLowerCase().slice(1) : ''
                  deliveryCity = deliveryCity ? deliveryCity.toLowerCase().charAt(0).toUpperCase() + deliveryCity.toLowerCase().slice(1) : ''
                  firstName = firstName ? firstName.toLowerCase().charAt(0).toUpperCase() + firstName.toLowerCase().slice(1) : ''
                  lastName = lastName ? lastName.toLowerCase().charAt(0).toUpperCase() + lastName.toLowerCase().slice(1) : ''
                  companyId = companyId ? companyId.trim() : companyId
                  
                  var leadInfoOk = true
                  if(!contactPhone && !contactEmail) {invalidContactDetails += rows +', '; leadInfoOk = false}
                  if(!companyName) {invalidCompanyNames += rows +', '; leadInfoOk = false}
                  if(!companyId) {invalidCompanyIds += rows +', '; leadInfoOk = false}
                  if(!deliveryPostalCode) {leadInfoOk = false}

                  if (existingCustomer){
                    console.log({
                      companyName,
                      companyId,
                      companyForm,
                      deliveryAddress,
                      deliveryPostalCode,
                      deliveryCity,
                      website,
                      firstName,
                      lastName,
                      contactPhone,
                      contactEmail,
                      contactRole,
                      companyRegistrationDate,
                      industryCode,
                      industryCodeName,
                      vainuLink,
                      staffNumber,
                      revenue,
                      message:'',
                      products:[],
                      source,
                      salesStatus:"not_contacted",
                      preparationStatus:"data_processing"
                    })
                  }

                  if(!existingLead && !existingCustomer && !alreadyProcessedEmail && leadInfoOk){
                    var lead = {
                      created_at:firebase.firestore.FieldValue.serverTimestamp(),
                      created_by:t.user.uid,
                      companyName,
                      companyId,
                      companyForm,
                      deliveryAddress,
                      deliveryPostalCode,
                      deliveryCity,
                      website,
                      firstName,
                      lastName,
                      contactPhone,
                      contactEmail,
                      contactRole,
                      companyRegistrationDate,
                      industryCode,
                      industryCodeName,
                      vainuLink,
                      staffNumber,
                      revenue,
                      message:'',
                      products:[],
                      source,
                      productInterest,
                      salesStatus:"not_contacted",
                      preparationStatus:"data_processing"
                    }
                    leads.push(lead)
                  }
                  //leadCompanyIds[companyIdSimple] && leadCompanyIds[companyIdSimple].length > 5
                  else if(existingLead && !existingCustomer && !alreadyProcessedEmail && leadInfoOk) {
                    var updateLead = {
                      id:existingLeadId,
                      companyName,
                      companyId,
                      companyForm,
                      deliveryAddress,
                      deliveryPostalCode,
                      deliveryCity,
                      website,
                      firstName,
                      lastName,
                      contactPhone,
                      contactEmail,
                      contactRole,
                      companyRegistrationDate,
                      industryCode,
                      industryCodeName,
                      vainuLink,
                      staffNumber,
                      revenue,
                      message:'',
                      products:[],
                      source,
                      productInterest
                      //preparationStatus:"data_processing"
                    }
                    if(t.leadsMap[existingLeadId] && !t.leadsMap[existingLeadId].created_at) updateLead.created_at = firebase.firestore.FieldValue.serverTimestamp()
                    if(t.leadsMap[existingLeadId] && !t.leadsMap[existingLeadId].created_by) updateLead.created_by = t.user.uid
                    
                    existingLeads.push(updateLead)
                  }
                }
                rows = rows+ 1
              },
              complete: async function(results) {
                console.log(leads)
                console.log(existingLeads)
                
                if(leads.length < 499){
                  await t.batchCreateLeads(leads)
                }
                else {
                  var rounds = leads.length/450
                  for(var i = 0; i <= rounds; i++){
                    var start = i * 450
                    console.log(leads.slice(start,start+450))
                  }
                }
                
                if(existingLeads.length < 499){
                  await t.batchUpdateLeads(existingLeads)
                }
                else {
                  var rounds = existingLeads.length/450
                  for(var i = 0; i <= rounds; i++){
                    var start = i * 450
                    console.log(existingLeads.slice(start,start+450))
                    await t.batchUpdateLeads(existingLeads.slice(start,start+450))

                  }
                }
                
                
                console.log({encodingOk,fieldsOk})

                if(!encodingOk) resolve(false)
                else if(!fieldsOk) resolve(false)
                else {
                  var msg = ''
                  invalidContactDetails ? msg += 'Seuraavat rivit eivät sisältäneet puhelinnumeroa eikä sähköpostia: ' + invalidContactDetails +'\n' : ''
                  invalidCompanyNames ? msg += 'Seuraavat rivit eivät sisältäneet yrityksen nimeä: ' + invalidCompanyNames +'\n': ''
                  invalidCompanyIds ? msg += 'Seuraavat rivit eivät sisältäneet y-tunnusta: ' + invalidCompanyIds +'\n' : ''
                  console.log(msg)
                  if(msg) {
                    msg = 'Joissain riveissä on puutteita. Katso tarkemmat tiedot tästä: ' + msg
                    t.$store.dispatch('showSnack', { snack:true, snackTimeout:7000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                  }
                  resolve(true)
                }
              }
            });
          }
          catch(e){
            console.log(e)
            resolve(false)
          }
        })
      },
      importRegions(){
        var states = {}
        var districts = {}
        var postalCodes = {}
        var t = this
        var rows = 0
        Papa.parse(fileInput.files[0], {
          step: function(row) {
            
            //console.log(rows)  
            //console.log("Row:", row.data)
            var stateNameFI = row.data[0]
            var stateNameSE = row.data[1]
            var stateCode = row.data[2]
            var districtNameFI = row.data[3]
            var districtNameSE = row.data[4]
            var districtCode = row.data[5]
            var postalCodeName = row.data[6]
            var postalCode = row.data[7]
            var salespersonFirstName = row.data[8]
            var salespersonLastName = row.data[9]
            salespersonFirstName = salespersonFirstName.trim()
            salespersonLastName = salespersonLastName.trim()
            //console.log(salespersonFirstName + ' ' + salespersonLastName)
            var salespersonId = ''
            for (const sp in t.staff) {
              var p = t.staff[sp]
              if(p.firstName === salespersonFirstName && p.lastName === salespersonLastName) salespersonId = sp
            }
            if(!salespersonId) console.log("HERE")
            else console.log("OK")
            if(rows > 0){
              states[stateCode] ? '' : states[stateCode] = {code:stateCode, name_fi:stateNameFI,name_se:stateNameSE}
              districts[districtCode] ? '' : districts[districtCode] = {code:districtCode, name_fi:districtNameFI,name_se:districtNameSE,stateCode}
              postalCodes[postalCode] ? '' : postalCodes[postalCode] = {stateCode,districtCode,code:postalCode,name_fi:postalCodeName, salesperson:salespersonId}
            }
            rows = rows+ 1
          },
          complete: function(results) {
            console.log(states)
            console.log(districts)
            console.log(postalCodes)
            t.saveRegions(states,districts,postalCodes)
          }
        });
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/AdditionalSales.vue